export default __webpack_public_path__ + "static/media/PLU-BEERCARD-A4-4-bckg-1.e970d795.jpg";